import { gql } from '@apollo/client'

export const typeDefs = gql`
  enum LagoApiError {
    internal_error
    Unauthorized
    forbidden
    not_found
    unprocessable_entity
    existing_code

    # Authentication & authentication errors
    token_encoding_error
    Token_Expired
    expired_jwt_token
    incorrect_login_or_password

    # Validation errors
    user_already_exists
    coupon_is_not_reusable
    currencies_does_not_match
    invite_not_found
    value_already_exist
    value_is_invalid
    value_is_out_of_range
    url_is_invalid
    invite_already_exists
    email_already_used
    does_not_match_item_amounts
    payment_processor_is_currently_handling_payment
    plan_overlapping

    # Object not found
    plan_not_found
    do_not_delete_plan
    invoice_not_found
    invoice_status_update_failed
  }
`

export const resolvers = {}
